import { render, staticRenderFns } from "./sendPointDialog.vue?vue&type=template&id=246ca4f2&scoped=true&"
import script from "./sendPointDialog.vue?vue&type=script&lang=js&"
export * from "./sendPointDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendPointDialog.vue?vue&type=style&index=0&id=246ca4f2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ca4f2",
  null
  
)

export default component.exports